import { render, staticRenderFns } from "./MinhaConta.vue?vue&type=template&id=08bd71c4"
import script from "./MinhaConta.vue?vue&type=script&lang=js"
export * from "./MinhaConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bd71c4')) {
      api.createRecord('08bd71c4', component.options)
    } else {
      api.reload('08bd71c4', component.options)
    }
    module.hot.accept("./MinhaConta.vue?vue&type=template&id=08bd71c4", function () {
      api.rerender('08bd71c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinhaConta.vue"
export default component.exports